var exports = {
  "X": "restoreLink__Myw5bb",
};

module.exports = exports;
